const zinc300 = '#D4D4D8'
// const zinc900 = '#18181B'
const zinc950 = '#09090B'

export type ThemeConfig = {
  light: Record<string, string>
  dark: Record<string, string>
  '--font-primary'?: string
}

export const searchbuttonConfig = {
  ui: {
    theme: {
      '--font-primary': '"Instrument Sans", sans-serif',
      light: {
        '--search-btn-text-color': '#54525B',
        '--search-btn-text-color-hover': '#54525B',
        '--search-btn-text-color-focus': '#54525B',

        '--search-btn-background-color': '#F6F8F9',
        '--search-btn-background-color-hover': '#F6F8F9',
        '--search-btn-background-color-focus': '#F6F8F9',

        '--search-btn-border-color': 'transparent',
        '--search-btn-border-color-hover': '#a8b1ff',
        '--search-btn-border-color-focus': '#a8b1ff',

        '--search-btn-icon-color': '#71717A'
      },
      dark: {
        '--search-btn-text-color': `${zinc300}`,
        '--search-btn-text-color-hover': `${zinc300}`,
        '--search-btn-text-color-focus': `${zinc300}`,

        '--search-btn-background-color': `${zinc950}`,
        '--search-btn-background-color-hover': `${zinc950}`,
        '--search-btn-background-color-focus': `${zinc950}`,

        '--search-btn-border-color': 'transparent',
        '--search-btn-border-color-hover': '#a8b1ff',
        '--search-btn-border-color-focus': '#a8b1ff',

        '--search-btn-icon-color': '#71717A'
      },
      system: {}
    }
  }
}

export const searchboxConfig = {
  ui: {
    theme: {
      '--font-primary': '"Instrument Sans", sans-serif',
      light: {
        '--text-color-primary': '#302F33',
        '--text-color-secondary': '#8E9298',
        '--text-color-reverse': '#F5F5F5',
        '--text-color-accent': '#6A4BB2',
        '--text-color-brand': '#335EF5', // NEW

        '--background-color-primary': '#F6F8F9',
        '--background-color-secondary': '#FCFCFC',
        '--background-color-tertiary': '#EDEDED',
        '--background-color-fourth': '#F6F8F9',
        '--background-color-accent': '#F4EFFF',
        '--background-color-reverse': '#000000',

        '--border-color-primary': '#E5E7EB',
        '--border-color-secondary': '#302F33',
        '--border-color-tertiary': '#D9D9D9',
        '--border-color-brand': '#335EF5', // NEW

        '--icon-color-primary': '#302F33',
        '--icon-color-secondary': '#8E9298',
        '--icon-color-accent': '#6A4BB2',

        // Start NEW
        '--icon-ai-color-primary': '#5E6685',
        '--icon-ai-color-secondary': '#CFD8F7',
        '--icon-ai-gradient-primary': '#C0CCF5',
        '--icon-ai-gradient-secondary': 'rgba(255, 255, 255, 0.00)',
        // End NEW

        '--backdrop-bg-color': 'rgba(0, 0, 0, 0.50)'
      },
      dark: {
        '--text-color-primary': '#F5F5F5',
        '--text-color-secondary': '#7F7D86',
        '--text-color-reverse': '#302F33',
        '--text-color-accent': '#D7A4FF',
        '--text-color-brand': '#335EF5',

        '--background-color-primary': '#000000',
        '--background-color-secondary': '#111111',
        '--background-color-tertiary': '#333333',
        '--background-color-fourth': '#1D1D1D',
        '--background-color-accent': '#211422',
        '--background-color-reverse': '#F6F8F9',

        '--border-color-primary': '#222222',
        '--border-color-secondary': '#F5F5F5',
        '--border-color-tertiary': '#333333',
        '--border-color-brand': '#335EF5', // NEW
        // Start NEW
        '--icon-ai-color-primary': '#5E6685',
        '--icon-ai-color-secondary': '#CFD8F7',
        '--icon-ai-gradient-primary': '#C0CCF5',
        '--icon-ai-gradient-secondary': 'rgba(255, 255, 255, 0.00)',
        // End NEW

        '--icon-color-primary': '#F5F5F5',
        '--icon-color-secondary': '#7F7D86',
        '--icon-color-accent': '#D7A4FF',

        '--backdrop-bg-color': 'rgba(0, 0, 0, 0.50)'
      },
      system: {}
    },
    layout: {
      area: {
        header: {},
        footer: {
          keyboardInstructions: true,
          poweredBy: 'orama'
        }
      }
    },
    placeholder: 'Search for something...'
  }
}
